module.exports = __webpack_public_path__ + "img/ic_my_medical.941dfbfd.png";